<template>
    <div class="rule tw-p-2">
        <label class="tw-text-sm">When Answer</label>
        <div class="rule-1 tw-flex tw-flex-row tw-flex-wrap tw-gap-2 tw-items-center tw-mb-2">
            <div class="rule-1-2">
                <WSSelect :options="operations" v-model="model.operation" text-attr="label"  />
            </div>
            <div class="rule-1-3 tw-w-full">
                <input v-if="!valueOptions" class="tw-form-input tw-border-gray-200 tw-rounded tw-w-full tw-text-sm" 
                       v-model="model.value" required>
                <WSSelect v-if="valueOptions" :options="valueOptions" v-model="model.value" direct />
            </div>
        </div>
        <label class="tw-text-sm">Then Go To Page</label>
        <div class="rule-2 tw-w-full tw-mb-3">
            <label class="tw-text-left tw-block tw-mb-1 tw-text-sm"></label>
            <WSSelect :options="pages" v-model="model.page" text-attr="name" value-attr="id" />
        </div>
        <span class="remove" @click="$emit('remove')">X</span>
    </div>
</template>

<script>
import WSSelect from "@/components/elements/WSSelect.vue";

export default {
    name: "PageLogicForm",
    components: {WSSelect},
    props: {
        rule: {
            type: Object,
            required: true
        },
        questions: {
            type: Array,
            required: true
        },
        pages:{
            type: Array,
            default: [],
        }
    },
    data() {
        return {
            model: {
                question: undefined,
                operation: undefined,
                value: undefined,
                page: undefined,
            },
        }
    },
    computed: {
        selectedQuestion() {
            return this.questions.find(({id}) => this.model.question === id);
        },
        operations() {
            const operations = [];

            if (['boolean'].includes(this.selectedQuestion.type)) {
                operations.push({value: 'eq', label: 'Is'},)
                operations.push({value: 'neq', label: 'Is Not'},)
            } else {
                operations.push({value: 'eq', label: 'is equal to'});
                operations.push({value: 'neq', label: 'is not equal to'});
                
                if (['opinion-scale', 'rating', 'ranking', 'number', 'date'].includes(this.selectedQuestion.type)) {
                    operations.push({value: 'lt', label: 'Lower than'},)
                    operations.push({value: 'lte', label: 'Lower than or equal'},)
                    operations.push({value: 'gt', label: 'Greater than'},)
                    operations.push({value: 'gte', label: 'Greater than or equal'},)
                } else {
                    operations.push({value: 'starts-with', label: 'starts with'});
                    operations.push({value: 'ends-with', label: 'ends with'});
                    operations.push({value: 'not-starts-with', label: 'does not starts with'});
                    operations.push({value: 'not-ends-with', label: 'does not ends with'});
                    operations.push({value: 'contains', label: 'contains'});
                }
            }

            return operations;
        },
        valueOptions() {
            if (this.selectedQuestion.type === 'boolean') {
                return [this.selectedQuestion.yes_value ?? 'Yes', this.selectedQuestion.no_value ?? 'No',]
            }
            if (['single-choice', 'multiple-choice',].includes(this.selectedQuestion.type)) {
                return this.selectedQuestion.options ?? []
            }
            if (['opinion-scale'].includes(this.selectedQuestion.type)) {
                return [...Array(parseInt((this.selectedQuestion.max_value ?? 5) + (1 - this.selectedQuestion.start_from_zero) )).keys()].map(i => this.selectedQuestion.start_from_zero ? i + 1 : i );
            }
            if (['rating'].includes(this.selectedQuestion.type)) {
                return [...Array(parseInt(this.selectedQuestion.max_value ?? 5)).keys()].map(i => i + 1);
            }
        }
    },
    watch: {
        model() {
            this.$emit('change', this.model)
        }
    },
    created() {
        this.model = {...this.rule}
        this.model.question = this.questions[0].id;
    },
}
</script>
